import { render, staticRenderFns } from "./trips.vue?vue&type=template&id=0d1eaeb2&scoped=true&"
import script from "./trips.vue?vue&type=script&lang=js&"
export * from "./trips.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d1eaeb2",
  null
  
)

export default component.exports